import { render, staticRenderFns } from "./SubjectSituation.vue?vue&type=template&id=0521b5ea&scoped=true&lang=pug&"
import script from "./SubjectSituation.vue?vue&type=script&lang=ts&"
export * from "./SubjectSituation.vue?vue&type=script&lang=ts&"
import style0 from "./SubjectSituation.vue?vue&type=style&index=0&id=0521b5ea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0521b5ea",
  null
  
)

export default component.exports